<template>
  <div id="projects">
    <v-toolbar>
      <v-toolbar-title>
        <span>{{'merchants._merchants_list_'|translate}} : {{merchants.length}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="newMerchants" color="primary" dark class="mb-2">{{'merchants._new_merchant_'|translate}}</v-btn>
<!--       <download-excel
        class="btn btn-default"
        :data="members"
        :fields="json_fields"
        type="csv"
        name="Projects.csv"
      >
        <button type="button" class="mb-2 v-btn theme--dark primary">Export to CSV</button>
      </download-excel> -->
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="merchants"
      :pagination.sync="pagination"
      :item-key="id"
      :loading="loading"
      class="elevation-1"
    >
    
      <template slot="items" slot-scope="props">
        <tr style="cursor: pointer">


          <td class="text-xs-left">{{ props.item.business_name }}</td>
          <td class="text-xs-left">{{ props.item.business_description }}</td>
          <td class="text-xs-left">{{ props.item.coupon_ids }}</td>
          <td class="text-xs-left">{{ props.item.created_by }}</td>   
            <td class="text-xs-left">{{ props.item.address }}</td>
              <td class="text-xs-left">{{ props.item.MerchantPoint }}</td>
            <td class="text-xs-left">{{ props.item.date_opened }}</td>


          <td class="text-xs-left">
            <div v-viewer class="images clearfix">

              <template >
                <img :src="props.item.imageUrl" class="image" >
                </template>

            </div>
          </td>
          <td class="text-xs-left">
            <v-btn @click.stop="editItem(props.item)" flat icon color="grey">
              <v-icon>edit</v-icon>
            </v-btn>
          </td>
            <td class="text-xs-left">
            <v-btn @click.stop="deleteMerchant(props.item)" flat icon color="grey">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { db } from "@/api/firebaseInit";
import firebase from "firebase";
export default {


  name: "widget-merchants",
  data() {
    return {
      created_by_id:"",
      created_by:'',
      merchant_id:'',
      loading: true,
      pagination: {
        sortBy: "title",
        rowsPerPage: "100"
      },
      id: null,

      headers: [
        {
          text: this.$t('merchants._merchants_buis_name_'),
          align: "left",
          value: "business_name"
        },
        { text: this.$t('merchants._merchants_descr_'), value: "business_description" },
        { text:this.$t('merchants._merchants_coupon_ids_') , value: "coupon_ids" },
        { text:this.$t('merchants._merchants_createdBy_') , value: "createdBy" },
         { text:this.$t('merchants._merchants_address_') , value: "address" },
          { text: this.$t('merchants._merchants_location_'), value: "location" },
        
          { text: 'date_opened', value: "date_opened" },
              { text: this.$t('merchants._merchants_imageUrl_'), value: "imageUrl" },
        { text: this.$t('merchants._merchants_Edit_btn_'), value: "Edit" },
        { text: this.$t('coupons._Delete_'), value: "Delete" }
      ],
 /*      json_fields: {
        "Nom du Projet": "title",
        "Type de projet": "type",
        Déscription: "description",
        Statut: "status",
        "Crée par": "createdBy"
      } */
    };
  },
     computed: {
    merchants(){
    
      let merchants =  this.$store.getters.merchants;
        this.loading=false
      return merchants;
    }
  },
    watch: {
   merchants(){
    
      let merchants =  this.$store.getters.merchants;
       this.loading=false
      return merchants;
    }
  },
    created() {  
    this.created_by_id = firebase.auth().currentUser.uid;
     this.created_by = firebase.auth().currentUser.displayName;
  },
  mounted() {
    //this.FetchProjects();
  },
  methods: {
   deleteMerchant(merchant) {
      var that = this;
      if (confirm("Are you sure?")) {
        db.collection("Merchants")
          .doc(merchant.merchant_id)
          .delete()
          .then(function() {
            alert('This Merchant was deleted');
           
          });
           this.$store.dispatch('fetchMerchants')
           // this.$router.push({name: 'widget-coupons'});
      }
    },
    editItem(item) {
      this.selected = item;
      this.$router.push({
        name: "components/modifiers-editmerchant",
        params: {
          merchant_id: item.merchant_id
        }
      });
    },
    newMerchants() {
      var address = {city:'',civic:'',Region:''}
      var location = []
      
       var operating_hours = [];
      const that = this;
      const memberRef = db.collection("Merchants").doc();
      const refKey = memberRef.id;
      this.merchant_id = refKey;
      memberRef
        .set({
          merchant_id: this.merchant_id,
          created_by: this.created_by,
          owner_id: this.created_by_id ,
          address: address,
          business_description:'',
          business_name:'',
          coupon_ids:[],
          created_date:new Date(),
          congregation :"bima",
          date_opened:new Date(),
          imageUrl:'', 
          location:location,
          operating_hours:operating_hours,
          phone:""  
        })
        .then(() => {
           this.$router.push({
            name: "components/modifiers-editmerchant",
            params: {
              merchant_id: that.merchant_id
            }
          });
        })
        .catch(error => {
          console.error("Error adding member: ", error);
        });
    }
  }
};
</script>
<style>
.image {
  height: 20px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/widgets/Merchants.vue